import { ROUTES } from '@router'

import { REVIEWS_TYPES } from '../../../helpers'

export const getReviewsType = ({ name }) =>
  REVIEWS_TYPES[
    Object.keys(ROUTES.REVIEWS.PAGES).find(
      (type) => ROUTES.REVIEWS.PAGES[type] === name,
    )
  ]

export const getNormalizedParams = ({ name, params }) => {
  switch (name) {
    case ROUTES.REVIEWS.PAGES.PRODUCT:
      return { id: params.productId }

    case ROUTES.REVIEWS.PAGES.LANDING:
      return { id: params.landingId, slug: params.landingSlug }

    case ROUTES.REVIEWS.PAGES.MERCHANT:
      return { id: params.sellerId }

    case ROUTES.REVIEWS.PAGES.ALL:
    default:
      return {}
  }
}
